import base from '../base/base';
import header from '../base/header';
import LazyloadVideo from '../../components/platformPlayer/LazyloadVideo';



// WEBPACK FOOTER //
// ./assets/layouts/big-board/big-board.js